import {
  getDefaultSalesReportFilter,
  SalesReportFilter,
  salesReportFilterToQueryParams,
} from '../SalesReport/SalesReportFilter';

export interface CustomerOrdersReportFilter extends SalesReportFilter {
  customerName?: string;
  email?: string;
}

export const getDefaultCustomerOrdersReportFilter =
  (): CustomerOrdersReportFilter => getDefaultSalesReportFilter();

export const customerOrdersReportFilterToQueryParams = (
  filter: CustomerOrdersReportFilter,
) => ({
  ...salesReportFilterToQueryParams(filter),
  'customer-name': filter.customerName || undefined,
  email: filter.email || undefined,
});
